'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UserProfile from 'MeetingsBase/models/UserProfile';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import H4 from 'UIComponents/elements/headings/H4';
import { NOT_FOUND, USER_NOT_FOUND, MEETING_PREVIOUSLY_CANCELLED, REBOOK_CONFLICT } from 'MeetingsLib/constants/errors';
import { getLongDisplayName } from 'MeetingsLib/utils/utils';
export default createReactClass({
  displayName: "Error",
  propTypes: {
    meetingCreationFailed: PropTypes.bool.isRequired,
    meetingRescheduleFailed: PropTypes.bool,
    meetingRescheduleError: PropTypes.string,
    profile: PropTypes.instanceOf(UserProfile),
    bookInfoFailed: PropTypes.bool,
    bookInfoError: PropTypes.string,
    meetingsUserFetchSuccess: PropTypes.bool,
    onFailure: PropTypes.func,
    NotFoundMarker: PropTypes.func.isRequired,
    ErrorMarker: PropTypes.func.isRequired
  },
  componentDidMount: function componentDidMount() {
    if (this.props.meetingCreationFailed) {
      this.props.onFailure();
    }
  },
  handleReloadPage: function handleReloadPage() {
    var _this$props = this.props,
        meetingRescheduleFailed = _this$props.meetingRescheduleFailed,
        meetingRescheduleError = _this$props.meetingRescheduleError;
    var retryRebook = meetingRescheduleError === REBOOK_CONFLICT;

    if (meetingRescheduleFailed && !retryRebook) {
      var route = document.location.origin + document.location.pathname;
      document.location = route;
    } else {
      document.location.reload(true);
    }
  },
  renderDescription: function renderDescription(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/_jsx("p", {
      className: "error-description",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message,
        options: options
      })
    }, "description");
  },
  renderEmail: function renderEmail() {
    var profile = this.props.profile;
    return /*#__PURE__*/_jsx("div", {
      className: "error-email",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "error.emailLink_jsx",
        options: {
          fullName: getLongDisplayName(profile),
          emailAddress: profile.email,
          linkProps: {
            href: "mailto:" + profile.email
          }
        },
        elements: {
          Link: UILink
        }
      })
    }, "email");
  },
  renderRetryButton: function renderRetryButton(desiredMessage) {
    var meetingRescheduleError = this.props.meetingRescheduleError;
    var retryRebook = meetingRescheduleError === REBOOK_CONFLICT;
    var message = desiredMessage || 'error.button';
    return /*#__PURE__*/_jsx("div", {
      className: "error-button-container",
      children: /*#__PURE__*/_jsx(UIButton, {
        use: retryRebook ? 'primary' : 'tertiary',
        className: retryRebook ? '' : 'error-button',
        onClick: this.handleReloadPage,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message
        })
      })
    }, "retry");
  },
  renderHeader: function renderHeader(message) {
    return /*#__PURE__*/_jsx(H4, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    }, "header");
  },
  renderCreateErrorWithReload: function renderCreateErrorWithReload() {
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      title: this.renderHeader('error.general.header'),
      children: [this.renderDescription('error.general.retryDescription'), this.renderRetryButton(), this.renderEmail()]
    });
  },
  renderRescheduleErrorWithReload: function renderRescheduleErrorWithReload(descriptionMessage, buttonMessage) {
    var desiredDescription = descriptionMessage || 'error.general.retryDescription';
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      title: this.renderHeader('error.general.header'),
      children: [this.renderDescription(desiredDescription), this.renderRetryButton(buttonMessage), this.renderEmail()]
    });
  },
  renderRescheduleConflict: function renderRescheduleConflict() {
    var buttonMessage = 'error.buttonRebookConflict';
    var desiredDescription = 'error.general.rebookConflictError';
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      title: this.renderHeader('error.general.header'),
      illustration: "meetings",
      children: [this.renderDescription(desiredDescription), this.renderRetryButton(buttonMessage)]
    });
  },
  renderInactiveState: function renderInactiveState() {
    var NotFoundMarker = this.props.NotFoundMarker;
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      type: "notFound",
      title: this.renderHeader('error.downgraded.header'),
      children: [this.renderDescription('error.downgraded.description'), this.renderEmail(), /*#__PURE__*/_jsx(NotFoundMarker, {})]
    });
  },
  renderLinkNotFound: function renderLinkNotFound() {
    var NotFoundMarker = this.props.NotFoundMarker;
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      className: "link-not-found",
      type: "notFound",
      title: this.renderHeader('error.general.header'),
      children: [this.renderDescription('error.general.genericDescription'), /*#__PURE__*/_jsx(NotFoundMarker, {})]
    });
  },
  renderError: function renderError() {
    var ErrorMarker = this.props.ErrorMarker;
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      children: [this.renderDescription('error.general.errorDescription'), /*#__PURE__*/_jsx(ErrorMarker, {})]
    });
  },
  renderRescheduleFailure: function renderRescheduleFailure() {
    var meetingRescheduleError = this.props.meetingRescheduleError;
    var rebookErrorMessage = 'error.general.rebookGeneralError';
    var rebookButtonMessage = 'error.buttonRebook';

    switch (meetingRescheduleError) {
      case MEETING_PREVIOUSLY_CANCELLED:
        return this.renderRescheduleErrorWithReload(rebookErrorMessage, rebookButtonMessage);

      case REBOOK_CONFLICT:
        return this.renderRescheduleConflict();

      default:
        return this.renderCreateErrorWithReload();
    }
  },
  renderDifferentMessages: function renderDifferentMessages() {
    var _this$props2 = this.props,
        meetingCreationFailed = _this$props2.meetingCreationFailed,
        bookInfoFailed = _this$props2.bookInfoFailed,
        bookInfoError = _this$props2.bookInfoError,
        meetingsUserFetchSuccess = _this$props2.meetingsUserFetchSuccess,
        meetingRescheduleFailed = _this$props2.meetingRescheduleFailed;

    if (meetingRescheduleFailed) {
      return this.renderRescheduleFailure();
    }

    if (meetingCreationFailed) {
      return this.renderCreateErrorWithReload();
    }

    if (bookInfoFailed && (bookInfoError === NOT_FOUND || bookInfoError === USER_NOT_FOUND)) {
      if (meetingsUserFetchSuccess) {
        return this.renderInactiveState();
      }

      return this.renderLinkNotFound();
    }

    return this.renderError();
  },
  render: function render() {
    return /*#__PURE__*/_jsx("div", {
      className: "meetings-error text-center",
      children: this.renderDifferentMessages()
    });
  }
});